import React from 'react';

function Pagination({ itemsPerPage, totalItems, currentPage, onPageChange }) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      onPageChange(pageNumber);
    }
  };

  const renderPaginationNumbers = () => {
    const paginationNumbers = [];
    let startPage = currentPage - 1;
    let endPage = currentPage + 1;

      if (startPage < 1) {
      startPage = 1;
      endPage = Math.min(3, totalPages); 
    }
    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = Math.max(1, totalPages - 2);
    }
  
    for (let i = startPage; i <= endPage; i++) {
      paginationNumbers.push(i);
    }
  
    return paginationNumbers.map((pageNumber) => (
      <button
        key={pageNumber}
        className={`"flex items-center justify-center px-3 h-8 leading-tight  border-spacing-3 border border-gray-300 hover:bg-gray-300 hover:text-gray-700 "  ${
          currentPage === pageNumber
            ? 'bg-[#cfebfd] text-black '
            : 'hover:bg-gray-200 text-white'
        }`}
        onClick={() => handlePageClick(pageNumber)}>
        {pageNumber}
      </button>
    ));
  }; 
  return (
    <div className= "flex items-center justify-end h-8 text-sm mt-1">
    <div className="flex ">
      <button className={`"flex items-center justify-center px-3 h-8 ml-0 leading-tight font-bold text-gray-500 border border-gray-300 rounded-l-lg rounded-r-none hover:bg-gray-100 hover:text-gray-700" ${
          currentPage === 1
            ? ' text-white rounded'
            : 'hover:bg-gray-200'
        }`}
        disabled={currentPage === 1}
        onClick={() => handlePageClick(currentPage - 1)}>
        {'<'}
      </button>
      {renderPaginationNumbers()}
      <button className={`"flex items-center justify-center px-3 h-8 ml-0 leading-tight font-bold text-white  border border-gray-300 rounded-r-lg rounded-l-none hover:bg-gray-100 hover:text-gray-700 " ${
          currentPage === totalPages
            ? ' text-white rounded'
            : 'hover:bg-gray-200'
        }`}
        disabled={currentPage === totalPages}
        onClick={() => handlePageClick(currentPage + 1)}>
        {'>'}
      </button>
    </div>
  </div>
  );
}
export default Pagination;
